module.exports = __webpack_public_path__ + "static/media/cup.7f28c5b2.svg";